// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"189":"d586b7868d2e5b7f1262","404":"228cb1635ce66a7d2c56","406":"f49d11b7829f010e6bbc","453":"db5319f20b88b1b48ec1"}[chunkId] + ".css";
};